import { render, staticRenderFns } from "./landingPagePreviewV2.vue?vue&type=template&id=4076df64&"
import script from "./landingPagePreviewV2.vue?vue&type=script&lang=js&"
export * from "./landingPagePreviewV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports